<template>
    <el-drawer :title="$t('resource.icon')" :visible.sync="drawer" :append-to-body="true" size="40%">
        <div class="icon-picker">
            <div class="search-bar">
                <el-input
                    v-model="searchVal"
                    clearable
                    size="small"
                    :placeholder="$t('resource.icon')"
                    prefix-icon="el-icon-search"
                ></el-input>
            </div>
            <div class="icon-grid">
                <div
                    v-for="item in filteredIcons"
                    :key="item"
                    class="icon-item"
                    :class="{ active: iconVal === item }"
                    @click="handleIcon(item)"
                >
                    <i :class="item"></i>
                    <span class="icon-name">{{ item.replace('el-icon-', '') }}</span>
                </div>
            </div>
            <el-empty v-if="filteredIcons.length === 0" :description="$t('resource.noData')" :image-size="60"></el-empty>
        </div>
        <div class="btn">
            <el-button type="primary" @click="drawer = false" style="margin-right:15px">{{ $t('public.btn_close') }}</el-button>
            <el-button type="primary" @click="handleSave">{{ $t('public.btn_confirm') }}</el-button>
        </div>
    </el-drawer>
</template>

<script>
export default {
    props: ['visible'],
    computed: {
        drawer: {
            get: function() {
                return this.visible;
            },
            set: function(val) {
                this.$emit('update:visible', val);
            }
        },
        filteredIcons() {
            if (!this.searchVal) return this.iconArray;
            const keyword = this.searchVal.toLowerCase();
            return this.iconArray.filter(item => item.toLowerCase().includes(keyword));
        }
    },
    data() {
        return {
            searchVal: '',
            iconVal: '',
            iconArray: [
                // System / Solid
                'el-icon-s-tools', 'el-icon-s-goods', 'el-icon-s-grid', 'el-icon-s-data',
                'el-icon-s-platform', 'el-icon-s-order', 'el-icon-s-management', 'el-icon-s-shop',
                'el-icon-s-marketing', 'el-icon-s-comment', 'el-icon-s-help', 'el-icon-s-opportunity',
                'el-icon-s-claim', 'el-icon-s-finance', 'el-icon-s-cooperation',
                'el-icon-s-open', 'el-icon-s-check', 'el-icon-s-flag',
                'el-icon-s-unfold', 'el-icon-s-fold', 'el-icon-s-ticket', 'el-icon-s-promotion',
                'el-icon-s-custom', 'el-icon-s-release',
                'el-icon-s-home', 'el-icon-s-operation',

                // Solid
                'el-icon-warning', 'el-icon-info', 'el-icon-platform-eleme', 'el-icon-user-solid',
                'el-icon-picture', 'el-icon-upload', 'el-icon-camera-solid', 'el-icon-video-camera-solid',
                'el-icon-message-solid', 'el-icon-star-on', 'el-icon-delete-solid', 'el-icon-edit',
                'el-icon-rank', 'el-icon-setting', 'el-icon-no-smoking', 'el-icon-smoking',
                'el-icon-magic-stick', 'el-icon-medal', 'el-icon-medal-1', 'el-icon-trophy',
                'el-icon-trophy-1', 'el-icon-phone', 'el-icon-phone-outline', 'el-icon-bell',
                'el-icon-message', 'el-icon-location', 'el-icon-location-information', 'el-icon-map-location',
                'el-icon-delete', 'el-icon-plus', 'el-icon-minus', 'el-icon-check',
                'el-icon-close', 'el-icon-search', 'el-icon-refresh', 'el-icon-refresh-left',
                'el-icon-refresh-right', 'el-icon-loading', 'el-icon-key', 'el-icon-lock',
                'el-icon-unlock', 'el-icon-aim', 'el-icon-c-scale-to-original', 'el-icon-reading',
                'el-icon-view', 'el-icon-cpu', 'el-icon-monitor', 'el-icon-mobile',
                'el-icon-headset', 'el-icon-suitcase', 'el-icon-suitcase-1', 'el-icon-toilet-paper',
                'el-icon-office-building', 'el-icon-shopping-cart-full', 'el-icon-shopping-cart-2',
                'el-icon-shopping-bag-1', 'el-icon-shopping-bag-2', 'el-icon-box', 'el-icon-takeaway-box',

                // Files & Data
                'el-icon-files', 'el-icon-folder', 'el-icon-folder-opened', 'el-icon-document',
                'el-icon-document-copy', 'el-icon-document-add', 'el-icon-document-delete', 'el-icon-document-checked',
                'el-icon-data-line', 'el-icon-data-board', 'el-icon-data-analysis', 'el-icon-pie-chart',
                'el-icon-receiving', 'el-icon-collection', 'el-icon-collection-tag', 'el-icon-coin',
                'el-icon-folder-add', 'el-icon-folder-remove', 'el-icon-folder-checked', 'el-icon-copy-document',

                // Food & Drink
                'el-icon-cold-drink', 'el-icon-coffee', 'el-icon-coffee-cup', 'el-icon-milk-tea',
                'el-icon-water-cup', 'el-icon-hot-water', 'el-icon-ice-cream', 'el-icon-ice-tea',
                'el-icon-lollipop', 'el-icon-dessert',
                'el-icon-ice-cream-round', 'el-icon-ice-cream-square',
                'el-icon-food', 'el-icon-chicken', 'el-icon-fork-spoon', 'el-icon-knife-fork',
                'el-icon-burger', 'el-icon-dish', 'el-icon-dish-1',
                'el-icon-goblet', 'el-icon-goblet-full', 'el-icon-goblet-square', 'el-icon-goblet-square-full',
                'el-icon-refrigerator', 'el-icon-grape', 'el-icon-watermelon', 'el-icon-cherry',
                'el-icon-apple', 'el-icon-pear', 'el-icon-orange',

                // Outline
                'el-icon-goods', 'el-icon-warning-outline', 'el-icon-user', 'el-icon-help',
                'el-icon-picture-outline', 'el-icon-picture-outline-round', 'el-icon-camera',
                'el-icon-video-camera', 'el-icon-star-off', 'el-icon-edit-outline',
                'el-icon-date', 'el-icon-time', 'el-icon-timer', 'el-icon-alarm-clock', 'el-icon-watch',

                // Directional
                'el-icon-arrow-up', 'el-icon-arrow-down', 'el-icon-arrow-left', 'el-icon-arrow-right',
                'el-icon-d-arrow-left', 'el-icon-d-arrow-right', 'el-icon-caret-top', 'el-icon-caret-bottom',
                'el-icon-caret-left', 'el-icon-caret-right', 'el-icon-sort', 'el-icon-sort-up',
                'el-icon-sort-down', 'el-icon-back', 'el-icon-right', 'el-icon-top',
                'el-icon-bottom', 'el-icon-top-right', 'el-icon-top-left', 'el-icon-bottom-right',
                'el-icon-bottom-left', 'el-icon-circle-plus', 'el-icon-remove', 'el-icon-success',
                'el-icon-error', 'el-icon-circle-check', 'el-icon-circle-close', 'el-icon-circle-plus-outline',
                'el-icon-remove-outline', 'el-icon-zoom-in', 'el-icon-zoom-out', 'el-icon-full-screen',

                // Edit / Action
                'el-icon-download', 'el-icon-upload2', 'el-icon-printer', 'el-icon-scissors',
                'el-icon-wallet', 'el-icon-money', 'el-icon-present',
                'el-icon-truck', 'el-icon-bicycle', 'el-icon-ship', 'el-icon-position',
                'el-icon-location-outline', 'el-icon-place', 'el-icon-discover',
                'el-icon-guide', 'el-icon-coordinate', 'el-icon-share',

                // Communication
                'el-icon-chat-dot-round', 'el-icon-chat-dot-square',
                'el-icon-chat-line-round', 'el-icon-chat-line-square', 'el-icon-chat-round',
                'el-icon-chat-square',

                // Weather
                'el-icon-sunny', 'el-icon-cloudy', 'el-icon-partly-cloudy', 'el-icon-sunrise',
                'el-icon-sunset', 'el-icon-moon', 'el-icon-moon-night', 'el-icon-lightning',
                'el-icon-heavy-rain', 'el-icon-light-rain', 'el-icon-cloudy-and-sunny',

                // Media
                'el-icon-video-pause', 'el-icon-video-play', 'el-icon-microphone',

                // Common
                'el-icon-more', 'el-icon-more-outline',
                'el-icon-umbrella', 'el-icon-discount',
                'el-icon-price-tag', 'el-icon-first-aid-kit',
                'el-icon-bangzhu', 'el-icon-link', 'el-icon-postcard'
            ]
        };
    },
    methods: {
        handleIcon(icon) {
            this.iconVal = icon;
        },
        handleSave() {
            if (!this.iconVal) {
                return this.$message.warning(this.$t('resource.iconNotEmpty'));
            }
            this.$emit('choozeIcon', this.iconVal);
        }
    }
};
</script>

<style lang="scss" scoped>
.icon-picker {
    padding: 0 20px;

    .search-bar {
        margin-bottom: 15px;
        position: sticky;
        top: 0;
        background: #fff;
        z-index: 10;
        padding: 10px 0;
    }

    .icon-grid {
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));
        gap: 10px;
        max-height: calc(100vh - 200px);
        overflow-y: auto;

        .icon-item {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            padding: 10px 5px;
            cursor: pointer;
            border: 1px solid #ebeef5;
            border-radius: 4px;
            transition: all 0.3s;

            &:hover {
                border-color: #409eff;
                background-color: #ecf5ff;
            }

            &.active {
                border-color: #409eff;
                background-color: #ecf5ff;
                box-shadow: 0 0 6px rgba(64, 158, 255, 0.3);
            }

            i {
                font-size: 24px;
                color: #344962;
                margin-bottom: 5px;
            }

            .icon-name {
                font-size: 10px;
                color: #909399;
                text-align: center;
                word-break: break-all;
                max-width: 90px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }
        }
    }
}

.btn {
    width: 100%;
    margin-top: 20px;
    text-align: center;
    padding-bottom: 20px;
}
</style>
